import { render, staticRenderFns } from "./employeePolicies.vue?vue&type=template&id=e0f13564&scoped=true"
import script from "./employeePolicies.vue?vue&type=script&lang=js"
export * from "./employeePolicies.vue?vue&type=script&lang=js"
import style0 from "./employeePolicies.vue?vue&type=style&index=0&id=e0f13564&prod&scoped=true&lang=css"
import style1 from "./employeePolicies.vue?vue&type=style&index=1&id=e0f13564&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0f13564",
  null
  
)

export default component.exports